export const CHANGE_SEGMENT = "app/SpotShipmentPage/CHANGE_SEGMENT";
export const PREFILL_SEGMENT = "app/SpotShipmentPage/PREFILL_SEGMENT";

export const LAYOUT_FLAVOR = {
  FREIGHT: "FRE",
};

export const SEGMENT_TYPES = {
  private: "private",
  business: "business",
};

export const CATEGORIES = {
  Pallet: "pallet",
  Containers: "containers",
  LooseGoods: "loose-goods",
  Parcel: "parcels",
  Truckload: "truckload",
};

export const SHIPMENT_TYPES = {
  Documents: "documents",
  NonDocuments: "non-documents",
};
